import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=5c68d592&scoped=true"
import script from "./clientDetail.vue?vue&type=script&lang=js"
export * from "./clientDetail.vue?vue&type=script&lang=js"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=5c68d592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68d592",
  null
  
)

export default component.exports